<template>
  <div ref="page">
    <div class="main">
      <header class="header">
        <div class="portal-header content-wrapper">
          <div class="container d-flex justify-content-between">
            <a
              href="/"
              aria-label="Portalnavn"
              :class="['logo', { 'by-night-logo': isByNight }]">
              <span class="d-none d-print-block">Greenbow</span>
            </a>
            <div class="solution-header d-none">
              <div class="container solution-header-inner">
                <h1 class="solution-heading">
                  <a href="#">{{ t('Layout.contentOnly.login') }}</a>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main class="main page-container">
        <slot />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
const route = useRoute();
const isByNight = ref(false);

onMounted(() => {
  isByNight.value = route.path === '/bestil-gbn';
});
</script>

<style lang="scss" scoped>
.main {
  background: '#fff ';
  min-height: 80vh;
}

.header {
  position: inherit;
}

.by-night-logo {
  background-image: url('/logos/by-night.svg');
}
</style>
